import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {  MAT_DIALOG_DATA,  MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export interface UnsavedChangesWarningDialogResponse {
    success?: boolean;
    save?: boolean;
}

@Component({
    templateUrl: './unsaved-changes-warning-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UnsavedChangesWarningDialogComponent {
    constructor(
        private readonly matDialogRef: MatDialogRef<UnsavedChangesWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) readonly data: { isValid$: Observable<boolean> },
    ) { }

    onConfirmation(isConfirm: boolean, isSave: boolean = false) {
        this.matDialogRef.close({
            success: isConfirm,
            save: isSave
        });
    }
}
